import { integrationRegistry } from "@p0security/shared/integrations/registry";
import { AssessmentScopeIntegration } from "@p0security/shared/types/assessment";
import { Select, Spacing, Typography } from "@p0security/ui";
import { useCallback, useContext, useEffect } from "react";

import { AllIntegrationLogos } from "../../Integrations/IntegrationLogo.tsx";
import { EnvironmentCreationContext } from "../contexts/EnvironmentCreationContext";

type NewAssessmentIntegrationSelectProps = {
  availableIntegrations: AssessmentScopeIntegration[];
};

const NewAssessmentIntegrationSelect = ({
  availableIntegrations,
}: NewAssessmentIntegrationSelectProps) => {
  const { currentIntegration, setCurrentIntegration } = useContext(
    EnvironmentCreationContext
  );
  const getTargetLogo = useCallback(
    (integration: AssessmentScopeIntegration) =>
      AllIntegrationLogos[integration],
    []
  );
  const selectProps = {
    placeholder: "Select an integration",
    onChange: (selectedValues: AssessmentScopeIntegration) => {
      setCurrentIntegration(selectedValues);
    },
    options: availableIntegrations.map((scope) => {
      return {
        value: scope,
        label: (
          <>
            {getTargetLogo(scope)} {integrationRegistry[scope].label}
          </>
        ),
      };
    }),
    value: currentIntegration,
  };

  useEffect(() => {
    if (availableIntegrations.length === 0) {
      setCurrentIntegration(undefined);
    }
    if (
      currentIntegration &&
      !availableIntegrations.includes(currentIntegration)
    ) {
      setCurrentIntegration(availableIntegrations[0]);
    }
  }, [availableIntegrations, currentIntegration, setCurrentIntegration]);

  return (
    <>
      <Spacing asChild mb="6px">
        <Typography.Paragraph>What should P0 assess?</Typography.Paragraph>
      </Spacing>
      <Spacing asChild mb="6px">
        <Select
          /* eslint-disable-line react/forbid-component-props */ style={{
            width: "100%",
          }}
          {...selectProps}
        />
      </Spacing>
    </>
  );
};

export default NewAssessmentIntegrationSelect;
